import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const { PURPLE, GREY } = colors;

const leftPanelStyle = makeStyles(() => ({
	heading: {
		fontSize: '32px',
		fontWeight: 300,
		fontFamily: 'Bogle-Light',
		padding: '0px 0px 40px 30px'
	},
	textHighlight: {
		color: PURPLE
	},
	tabsIndicator: {
		height: 4,
		borderRadius: [[100, 100, 0, 0]],
		color: GREY
	},
	tabsRoot: {
		borderBottom: `1px solid #E3E4E5`,
		minHeight: 22,
		height: 37,
		width: (P) => `${P.show ? 'calc(100vw - 420px)' : 'calc(100vw - 60px)'}`,
		margin: '0 30px'
	},
	tabRoot: {
		color: GREY,
		textTransform: 'capitalize !important',
		minHeight: 22,
		marginRight: 24,
		fontFamily: 'Bogle-Regular !important',
		fontSize: '16px !important',
		height: '100% !important'
	}
}));

export default leftPanelStyle;
